import React, { useState, useEffect } from 'react';
import { FiLogOut, FiVideo } from 'react-icons/fi';
import logo from '../assets/logo.png';

interface HeaderProps {
  onLoginClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onLoginClick }) => {
  const [user, setUser] = useState<{ fullName: string; email: string; status?: string } | null>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) setUser(JSON.parse(userData));
    else setUser(null);
  }, []);
console.log(user,'....usere')
  // Get initials for avatar
  const getInitials = (name: string) =>
    name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase();

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
    setDrawerOpen(false);
    window.location.reload();
  };

  return (
    <header style={{
      width: '100%',
      background: '#fff',
      borderBottom: '1px solid #eee',
      padding: '0 16px',
      boxSizing: 'border-box',
      fontFamily: 'Inter, Arial, sans-serif',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
    }}>
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end', // Always right
        height: 64,
      }}>
        {user ? (
          <div style={{ position: 'relative' }}>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #f4c542 0%, #ffe082 100%)',
                color: '#222',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: '1.2rem',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(244,197,66,0.10)',
                userSelect: 'none',
                border: '2px solid #fff',
                transition: 'box-shadow 0.2s',
              }}
              onClick={() => setDrawerOpen((v) => !v)}
              tabIndex={0}
              aria-label="User menu"
            >
              {getInitials(user.fullName)}
            </div>
            {drawerOpen && (
              <div style={{
                position: 'absolute',
                top: 60,
                right: 0,
                minWidth: 220,
                background: '#fff',
                borderRadius: 12,
                boxShadow: '0 8px 32px rgba(60,60,60,0.18)',
                padding: '18px 0 8px 0',
                zIndex: 200,
                animation: 'fadeInDropdown 0.2s',
              }}>
                <div style={{ padding: '0 24px 8px 24px', borderBottom: '1px solid #f4c54233', marginBottom: 8 }}>
                  <div style={{ fontWeight: 600, fontSize: '1.08rem', color: '#23272e', marginBottom: 2 }}>{user.fullName}</div>
                  <div style={{ fontSize: '0.97rem', color: '#888', marginBottom: 8 }}>{user.email}</div>
                </div>
                {user && user.status === 'succeeded' ? (
                  <a
                    href="/course-video"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '12px 24px',
                      fontSize: '1.05rem',
                      color: '#1976d2',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      border: 'none',
                      background: 'none',
                      width: '100%',
                      textAlign: 'left',
                      fontWeight: 600,
                    }}
                  >
                    <FiVideo style={{ marginRight: 8, verticalAlign: 'middle' }} /> Viral Agency Course Video
                  </a>
                ) : (
                  <button style={{
                    padding: '12px 24px',
                    fontSize: '1.05rem',
                    color: '#aaa',
                    cursor: 'not-allowed',
                    opacity: 0.7,
                    border: 'none',
                    background: 'none',
                    width: '100%',
                    textAlign: 'left',
                  }} disabled>
                    <FiVideo style={{ marginRight: 8, verticalAlign: 'middle' }} /> Viral Agency Course Video
                  </button>
                )}
                <hr style={{ height: 1, background: '#f4c54233', margin: '8px 0', border: 'none' }} />
                <button style={{
                  padding: '12px 24px',
                  fontSize: '1.05rem',
                  color: '#23272e',
                  cursor: 'pointer',
                  border: 'none',
                  background: 'none',
                  width: '100%',
                  textAlign: 'left',
                }} onClick={handleLogout}>
                  <FiLogOut style={{ marginRight: 8, verticalAlign: 'middle' }} /> Logout
                </button>
              </div>
            )}
          </div>
        ) : (
          <button
            onClick={onLoginClick}
            style={{
              background: '#f4c542',
              color: '#000',
              border: 'none',
              borderRadius: 6,
              padding: '10px 28px',
              fontWeight: 600,
              fontSize: '1.1rem',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(244,197,66,0.10)',
              transition: 'background 0.2s',
              fontFamily: 'inherit',
            }}
          >
            Login
          </button>
        )}
      </div>
      <style>{`
        @keyframes fadeInDropdown {
          0% { opacity: 0; transform: translateY(-10px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </header>
  );
};

export default Header; 